import React from 'react'

const Marketplace = () => {
  return (
    <div>
      THIS IS MARKETPLACE
    </div>
  )
}

export default Marketplace
